import { Component } from '@angular/core';

@Component({
  selector: 'app-checked-pass-word',
  templateUrl: './checked-pass-word.component.html',
  styleUrls: ['./checked-pass-word.component.css']
})
export class CheckedPassWordComponent {

}
